import Home from "../components/home/Home";
import NotFound from "@/components/common/NotFound";
import { isProspect } from "@/utils/type";

function HomePage({ type }) {
    return isProspect(type) ? <Home /> : <NotFound />;
}

export async function getStaticProps() {
    return { props: { type: process.env.NEXT_PUBLIC_TYPE } };
}

export default HomePage;
